// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CVCard.css */
/* Note: Uses utilities: .section-title for cvOrg styling */

.cvSection {
  margin-bottom: 1.25em;
}

.cvSection > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cvRole {
  margin: 0 0 var(--spacing-xs) 0;
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cvRole:last-child {
  margin-bottom: 0;
}

.cvRoleHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--spacing-sm);
}

.cvRoleHeader h4,
.cvRoleHeader time {
  margin: 0;
}

.cvRolePeriod {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-tight);
}

@media (max-width: 640px) {
  .cvRoleHeader {
    flex-direction: column;
    align-items: flex-start;
  }
}

.cvOrg {
  font-weight: 600;
  color: var(--color-primary);
  margin: 0;
}

.cvDescriptionWrap {
  margin: 0;
  position: relative;
  isolation: isolate;
}

.cvDescriptionText {
  margin: 0;
  width: 100%;
  max-width: none;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: var(--line-height-base);
  padding-right: 4.5em;
  overflow: hidden;
}

.cvDescriptionText.isExpanded {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  padding-right: 0;
  overflow: visible;
}

.cvDescriptionToggle {
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: var(--color-primary);
  cursor: pointer;
  font: inherit;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-base, 1.5);
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: var(--color-card-bg);
  white-space: nowrap;
  min-height: auto;
  min-width: auto;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  z-index: 0;
}

.cvDescriptionWrap .cvDescriptionText:not(.isExpanded) + .cvDescriptionToggle {
  top: calc(100% - 1.5em + 0.28em - 11px);
  bottom: auto;
  transform: translateY(7px);
}

.cvDescriptionText.isExpanded + .cvDescriptionToggle {
  position: static;
  display: inline;
  padding-left: 0;
  top: auto;
  bottom: auto;
  transform: none;
}

.cvSkill, .cvLanguage {
  text-align: left;
  margin: var(--spacing-xs) 0;
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
}

.cvSection h3 {
  color: var(--color-text);
  font-size: var(--font-size-lg);
  font-weight: 600;
  line-height: var(--line-height-tight);
  margin-bottom: var(--spacing-xs);
  border-bottom: 1px solid var(--color-border-pale);
  padding-bottom: var(--spacing-xs);
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/CVCard.css"],"names":[],"mappings":"AAAA,eAAe;AACf,2DAA2D;;AAE3D;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;EAChC,iDAAiD;EACjD,iCAAiC;AACnC","sourcesContent":["/* CVCard.css */\n/* Note: Uses utilities: .section-title for cvOrg styling */\n\n.cvSection {\n  margin-bottom: 1.25em;\n}\n\n.cvSection > ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.cvRole {\n  margin: 0 0 var(--spacing-xs) 0;\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.cvRole:last-child {\n  margin-bottom: 0;\n}\n\n.cvRoleHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--spacing-sm);\n}\n\n.cvRoleHeader h4,\n.cvRoleHeader time {\n  margin: 0;\n}\n\n.cvRolePeriod {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-tight);\n}\n\n@media (max-width: 640px) {\n  .cvRoleHeader {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.cvOrg {\n  font-weight: 600;\n  color: var(--color-primary);\n  margin: 0;\n}\n\n.cvDescriptionWrap {\n  margin: 0;\n  position: relative;\n  isolation: isolate;\n}\n\n.cvDescriptionText {\n  margin: 0;\n  width: 100%;\n  max-width: none;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  line-height: var(--line-height-base);\n  padding-right: 4.5em;\n  overflow: hidden;\n}\n\n.cvDescriptionText.isExpanded {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n  padding-right: 0;\n  overflow: visible;\n}\n\n.cvDescriptionToggle {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--color-primary);\n  cursor: pointer;\n  font: inherit;\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-base, 1.5);\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: var(--color-card-bg);\n  white-space: nowrap;\n  min-height: auto;\n  min-width: auto;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n  z-index: 0;\n}\n\n.cvDescriptionWrap .cvDescriptionText:not(.isExpanded) + .cvDescriptionToggle {\n  top: calc(100% - 1.5em + 0.28em - 11px);\n  bottom: auto;\n  transform: translateY(7px);\n}\n\n.cvDescriptionText.isExpanded + .cvDescriptionToggle {\n  position: static;\n  display: inline;\n  padding-left: 0;\n  top: auto;\n  bottom: auto;\n  transform: none;\n}\n\n.cvSkill, .cvLanguage {\n  text-align: left;\n  margin: var(--spacing-xs) 0;\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n}\n\n.cvSection h3 {\n  color: var(--color-text);\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  line-height: var(--line-height-tight);\n  margin-bottom: var(--spacing-xs);\n  border-bottom: 1px solid var(--color-border-pale);\n  padding-bottom: var(--spacing-xs);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
